export const DEFAULT_LANG = 'fr';
export const DEFAULT_CURRENCY = '€';
